import { extend } from "vee-validate";
import { required, regex } from "vee-validate/dist/rules";

extend("required", { ...required, message: "This field is required." });
extend("rut", {
  validate: val => {
    const regex = /^(\d{1,3}(?:\.\d{1,3}){2}-[\dkK])$/.test(val);
    return regex && required.validate(val);
  },
  message: "The R.U.T is invalid."
});
